import styled from "styled-components";

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;
export const SignUpContainer = styled.div`
    display: flex;
    gap: 24px;
    width: 100%;
    max-width: 480px;
`;
export const AgreementText = styled.h5`
    color: #FFFFFF;
    font-weight: 500;
    margin: 0;
    text-align: center;
    width: 100%;
`;
export const VerificationContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;